/*eslint-disable */

import {bus} from '@/main';
import loader from '@/components/common/component-small-loader';
import replyMessageOfpatient from "./reply-message-of-patient/index.vue";

export default {
  name: 'message-of-patient',
  components: {
    'reply-message' : replyMessageOfpatient,
    loader
  },
  props: [],
  data () {
    return {
      msgPatientListData:null,
      msgPatientListDataResults:[],
      replyMsgId:''
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('replyAgainMessageDataBus', (data) => {
      this.msgPatientListData = data;
      this.msgPatientListDataResults = this.msgPatientListData.data;
    });
    bus.$on('directSmsForPopupBus', (data) => {
      this.replyMsgId = ''
    });
    this.getMessageOfPatientmethod()
  },
  methods: {
    replyMsgOfPatientMethod(id){
      this.replyMsgId = id
    },
    messageListOfPatientPopupClosedMethod(){
      bus.$emit('messageListOfPatientPopupBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    getMessageOfPatientmethod(){
      this.$store.dispatch('getpatientMessageListMethod').then((res) => {
        this.msgPatientListData = res.data.data;
        this.msgPatientListDataResults = this.msgPatientListData.data;
      })
    },
  }
}